import api from './api';

// Leads
export const getLeads = (params = {}) => api.get('/crm/leads', { params });
export const getLead = (id) => api.get(`/crm/leads/${id}`);
export const createLead = (data) => api.post('/crm/leads', data);
export const updateLead = (id, data) => api.put(`/crm/leads/${id}`, data);
export const updateLeadStage = (id, stage) => api.put(`/crm/leads/${id}/stage`, { stage });
export const rescoreLead = (id) => api.post(`/crm/leads/${id}/rescore`);
export const deleteLead = (id) => api.delete(`/crm/leads/${id}`);
export const bulkDeleteLeads = (data) => api.post('/crm/leads/bulk-delete', data);

// CSV Import
export const importLeadsCSV = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.post('/crm/leads/import-csv', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

// CSV Export
export const exportLeadsCSV = () => api.get('/crm/leads/export-csv', { responseType: 'blob' });

// Pipeline
export const getPipeline = () => api.get('/crm/pipeline');

// Sync & Analytics
export const syncLeads = () => api.post('/crm/sync');
export const getCrmAnalytics = () => api.get('/crm/analytics');
